import React, { useState, useRef, useLayoutEffect } from 'react';
import { PropTypes } from 'prop-types';
import { CarouselProvider, CarouselContext, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

/**
 * Slider
 */
const TemplateCarouselSlider = ({ boxStyle, slideBoxSet, contentSet, contentCount, sliderId }) => {
  const items = [];
  // set
  const [visibleSlides, setVisibleSlides] = useState(1);
  const slideBoxSize = slideBoxSet.width + slideBoxSet.margin * 2;
  const messageBoxDef = useRef(0);

  useLayoutEffect(() => {
    let clientWidth = messageBoxDef.current.clientWidth;
    setVisibleSlides(clientWidth / slideBoxSize);
    function handleResize(a) {
      clientWidth = messageBoxDef.current.clientWidth;
      setVisibleSlides(clientWidth / slideBoxSize);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="_carousel_div" ref={messageBoxDef}>
      <CarouselProvider
        visibleSlides={visibleSlides}
        className="_message_temp_carousel_div"
        totalSlides={contentCount}
        dragEnabled={false}
        touchEnabled
        isPlaying={false}
        currentSlide={0}
      >
        <Slider style={{ outline: 'none' }} id={sliderId} aria-label={`검색 결과 ${contentCount}건 슬라이드`}>
          {contentSet()}
        </Slider>
        <ButtonBack className="_back_button" aria-label="이전 슬라이드">
          <i className="ri-arrow-left-circle-fill" aria-hidden="true" />
        </ButtonBack>
        <ButtonNext className="_next_button" aria-label="다음 슬라이드">
          <i className="ri-arrow-right-circle-fill" aria-hidden="true" />
        </ButtonNext>
      </CarouselProvider>
    </div>
  );
};

TemplateCarouselSlider.propTypes = {
  boxStyle: PropTypes.object,
  slideBoxSet: PropTypes.object,
  contentCount: PropTypes.number,
  contentSet: PropTypes.func,
  sliderId: PropTypes.string,
};
TemplateCarouselSlider.defaultProps = {
  boxStyle: {},
  slideBoxSet: { width: 300, margin: 15, height: '200px' },
  contentCount: 0,
  contentSet: () => {},
  sliderId: 'slider',
};

export default TemplateCarouselSlider;
